import React, { useState, useEffect } from 'react';
import './PWAInstallPrompt.css';

const PWAInstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showPrompt, setShowPrompt] = useState(false);
  const [isManagerPath, setIsManagerPath] = useState(
    typeof window !== 'undefined' && window.location.pathname.includes('/manager')
  );

  useEffect(() => {
    // Keep track of SPA navigation so the prompt only appears on /manager routes
    const handleLocationChange = () => {
      setIsManagerPath(window.location.pathname.includes('/manager'));
    };

    // patch history methods to emit a locationchange event for SPA navigation
    const origPush = window.history.pushState;
    const origReplace = window.history.replaceState;
    window.history.pushState = function () {
      const res = origPush.apply(this, arguments);
      window.dispatchEvent(new Event('locationchange'));
      return res;
    };
    window.history.replaceState = function () {
      const res = origReplace.apply(this, arguments);
      window.dispatchEvent(new Event('locationchange'));
      return res;
    };
    window.addEventListener('popstate', handleLocationChange);
    window.addEventListener('locationchange', handleLocationChange);
    const handleBeforeInstallPrompt = (e) => {
      // Prevent the default install prompt
      e.preventDefault();
      // Store the event for later use
      setDeferredPrompt(e);
      
      // Check if already installed (persistent check)
      if (localStorage.getItem('pwa-installed') === 'true') {
        console.log('[PWA] App was previously installed, hiding prompt');
        setShowPrompt(false);
        return;
      }
      
      // Show our custom install prompt
      setShowPrompt(true);
      console.log('[PWA] Install prompt available');
    };

    const handleAppInstalled = () => {
      console.log('[PWA] App successfully installed');
      localStorage.setItem('pwa-installed', 'true');
      setShowPrompt(false);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    window.addEventListener('appinstalled', handleAppInstalled);

    // Check if already installed (either in standalone or previously installed)
    if (window.matchMedia('(display-mode: standalone)').matches || 
        localStorage.getItem('pwa-installed') === 'true') {
      console.log('[PWA] App is already installed');
      setShowPrompt(false);
    }

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
      window.removeEventListener('appinstalled', handleAppInstalled);
      window.removeEventListener('popstate', handleLocationChange);
      window.removeEventListener('locationchange', handleLocationChange);
      window.history.pushState = origPush;
      window.history.replaceState = origReplace;
    };
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) {
      return;
    }

    // Show the install prompt
    deferredPrompt.prompt();

    // Wait for the user's response
    const { outcome } = await deferredPrompt.userChoice;
    console.log(`[PWA] User response to install prompt: ${outcome}`);

    if (outcome === 'accepted') {
      // Mark as installed
      localStorage.setItem('pwa-installed', 'true');
    }

    // Clear the deferred prompt
    setDeferredPrompt(null);
    setShowPrompt(false);
  };

  const handleDismiss = () => {
    setShowPrompt(false);
    // Remember dismissal in session
    sessionStorage.setItem('pwa-install-dismissed', 'true');
  };

  // Don't show if dismissed in this session
  if (sessionStorage.getItem('pwa-install-dismissed')) {
    return null;
  }

  // Only ever display on manager pages
  if (!isManagerPath) {
    return null;
  }

  if (!showPrompt) {
    return null;
  }

  return (
    <div className="pwa-install-prompt">
      <div className="pwa-install-content">
        <div className="pwa-install-icon">📱</div>
        <div className="pwa-install-text">
          <h3>Install PPE SCOPE</h3>
          <p>Install this app for a better experience with offline access</p>
        </div>
        <div className="pwa-install-actions">
          <button className="pwa-install-btn" onClick={handleInstallClick}>
            Install
          </button>
          <button className="pwa-dismiss-btn" onClick={handleDismiss}>
            Not Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default PWAInstallPrompt;
